import React from 'react';

import './HelpBox.css';


import { ReactComponent as CaretIcon } from '../../icons/caret.svg';
import { ReactComponent as ChevronIcon } from '../../icons/chevron.svg';
import { ReactComponent as CloseIcon } from '../../icons/close.svg';
import { ReactComponent as HelpIcon } from '../../icons/help.svg';


class HelpBox extends React.Component {

	// component renders a toggable box 
	// that typically contains additiona help text


	selectIcon() {
		// method to return either open or close icon based on current open value passed in props

		const closeIcon = <CloseIcon/>;
		const openIcon = <HelpIcon/>;
		
		return this.props.expanded ? closeIcon: openIcon	
		
	}

	selectLabelText() {
		// returns text for open/close cases

		return this.props.expanded ? 'Close' : 'More Info'

	}

	renderTopBar() {
		// method to render the top "button" portion of the collapisble help menu

		return(
			<div className='np-help-toggle-section-bar'>
				<div className='np-help-toggle-btn' onClick={this.props.toggleExpand}>
					<div className='np-help-toggle-icon'>{this.selectIcon()}</div>
					<h2 className='np-help-toggle-section-label'>{this.selectLabelText()}</h2>
				</div>
			</div>
		)
	}

	render() {

		// content passed to component that is only displayed if 'expanded' prop is true
		var content = <div className='np-help-toggle-section-content'>{this.props.children}</div>

		return(
			<div className='np-help-toggle-section'>
				{this.renderTopBar()}
				{this.props.expanded ? content : null}
			</div>
		)
	}

}

export default HelpBox;